import { z } from 'zod';

/**
 * Closing your own account — `DELETE /me` (Apple 5.1.1(v)).
 *
 * **The password is the second confirmation, and it is deliberately not a typed
 * phrase.** A phrase ("DELETE") would have to be translated (U8) or kept in
 * English against an Arabic-first product, and it proves only that the person
 * can read the screen. A password proves possession, which is what the control
 * actually needs to be safe on an unlocked phone somebody left on a table.
 *
 * **Not trimmed**, unlike every other string in this package: leading and
 * trailing spaces are legitimate password bytes, and normalising them here would
 * refuse a member their own account.
 *
 * `.strict()` is load-bearing beyond the usual N7 reason — it is what makes a
 * body naming another account a refusal rather than a field somebody could one
 * day read. There is no admin variant of this route: staff take an account out
 * of service with a status change (N9), never by deleting it.
 */
export const AccountDeleteSchema = z
  .object({
    password: z.string().min(1),
  })
  .strict();

export type AccountDeleteRequest = z.infer<typeof AccountDeleteSchema>;
